import { Link } from "react-router-dom";
import Auth from "../../Auth/Auth";
import { connect } from "react-redux";
import Styles from "./index.module.sass";
import { DefaultButton } from "office-ui-fabric-react";

interface CartButtonProps
{
    cartLines: any[];
    sending: boolean;
    activePlanType?: number;
}

function mapCartStateToProps(state: any)
{
    const isUserSuscribedUser = Auth.isSubscribed();
    // Tipo del plan activo desde el store (re-renderiza al cambiar de plan); si aún no se ha hidratado, desde localStorage
    const activePlanType = state.auth?.userActivePlan?.type ?? Auth.getActivePlan()?.type;

    if(!isUserSuscribedUser)
    {
        return{
            cartLines: state.educationalCart.cartLines,
            sending: state.educationalCart.sending || false,
            activePlanType: activePlanType,
        };
    }
    else
    {
        return{
            cartLines: state.cart.cartLines,
            sending: state.cart.sending || false,
            activePlanType: activePlanType,
        };
    }
}

const CartButton = ((props: CartButtonProps) =>
{
    const isActiveManagementPlan = Auth.isActiveManagementPlan();
    const isUserSuscribed = Auth.isSubscribed();

    if(isActiveManagementPlan === true)
    {
        return <></>;
    }
    else
    {
        // Los planes de Educación Financiera (tipo 5) usan su propio carrito también para los suscritos
        return(
            <Link to={isUserSuscribed && props.activePlanType !== 5 ? "/cart" : "/cart-ef"}>
                <div className={`${Styles.CartButton} ${props.sending ? Styles.Sending : ""}`}>
                    <div className={`${Styles.BadgeButton} badge`}>
                        {props.cartLines?.length || 0}
                    </div>
                    <DefaultButton title="Carrito">
                        <i className="ironia-icon shopping-cart" />
                    </DefaultButton>
                </div>
            </Link>
        );
    }
});

export default connect(mapCartStateToProps)(CartButton);